import { Nullable } from '@crossbeam/types';

import { storeToRefs } from 'pinia';
import { ref } from 'vue';

import { ChatErrorCode, useWebSocketStore } from '@/stores/MCPWebsocketStore';

export type ReceivedMessage = {
  role: 'user' | 'bot';
  content: string;
  errorCode?: Nullable<ChatErrorCode>;
  messageId?: string;
};

export type MessageFeedback = {
  id: string;
  feedback: 'like' | 'dislike';
};

export function useAIChatState() {
  const wsStore = useWebSocketStore();
  const { parsedMessages, chatSessionId, connectionFailed, isConnected } =
    storeToRefs(wsStore);

  const isChatResponding = ref(false);
  const waitingOnResponse = ref(false);
  const hasReceivedFirstResponse = ref(false);
  const nextMessage = ref('');

  const receivedMessagesInOrder = ref<ReceivedMessage[]>([]);
  const currentMessageEndIndex = ref(0);

  const error = ref<Nullable<ChatErrorCode>>(null);

  const messagesWithFeedback = ref<MessageFeedback[]>([]);

  return {
    receivedMessagesInOrder,
    currentMessageEndIndex,
    wsStore,
    parsedMessages,
    isChatResponding,
    nextMessage,
    hasReceivedFirstResponse,
    chatSessionId,
    messagesWithFeedback,
    error,
    waitingOnResponse,
    connectionFailed,
    isConnected,
  };
}
